<article class="tw-rounded-lg tw-shadow-tb tw-p-3 tw-bg-white {{customClass}} tw-overflow-hidden">
  <ng-content></ng-content>
</article>
